import React from "react";
import { DeviceHardwareCellTemplate } from "themes/administration/analytics/components";

function DeviceHardwareCell(props) {
    return <DeviceHardwareCellTemplate {...props} />;
}

export default DeviceHardwareCell;
